import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { appInsights } from "../../core/services/insight.service";

const AccountsGuide = () => {
  const navigate = useNavigate();
  
  useEffect(() => {
    const currentPage = window.location.href;
    const handlePopState = () => {
      if (document.referrer.includes(window.location.host)) {
        navigate('/home');
      }
    };
    window.addEventListener('popstate', handlePopState);
    try {
      window.location.replace('http://acctg.lagnr.chevron.com/');
    } catch (error: any) {
      appInsights.trackEvent({ name: "NavigationFailed", properties: { error: error } });
    }
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [navigate]);
  return null;
};

export default AccountsGuide;